var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTramites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath20",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd"
    },
    id: "path18",
    d: "m 160,510 h 189.332 c 16.57,0 30,-13.43 30,-30 V 211.332 c 0,-16.566 -13.43,-30 -30,-30 H 160 c -16.57,0 -30,13.434 -30,30 V 480 c 0,16.57 13.43,30 30,30 z"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath26",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M 0,0 H 600 V 600 H 0 Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath36",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd"
    },
    id: "path34",
    d: "m 379.258,464.668 h 11.41 c 18.777,0 34,-15.223 34,-34 V 170 c 0,-18.777 -15.223,-34 -34,-34 H 209.332 c -18.777,0 -34,15.223 -34,34 v 11.078"
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath42",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M 0,0 H 600 V 600 H 0 Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath52",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd"
    },
    id: "path50",
    d: "M 424.59,419.332 H 436 c 18.777,0 34,-15.223 34,-34 V 124.668 c 0,-18.777 -15.223,-34 -34,-34 H 254.668 c -18.777,0 -34,15.223 -34,34 v 11.078"
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath58",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "M 0,0 H 600 V 600 H 0 Z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath88",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "m 425,340 c 46.945,0 85,38.055 85,85 0,46.945 -38.055,85 -85,85 -46.945,0 -85,-38.055 -85,-85 0,-46.945 38.055,-85 85,-85 z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath94",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "M 0,0 H 600 V 600 H 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,80)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath20)",
    id: "g16"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath26)",
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "none",
      stroke: "#c4d2e4",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 160,510 h 189.332 c 16.57,0 30,-13.43 30,-30 V 211.332 c 0,-16.566 -13.43,-30 -30,-30 H 160 c -16.57,0 -30,13.434 -30,30 V 480 c 0,16.57 13.43,30 30,30 z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g30"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath36)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath42)",
    id: "g38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "none",
      stroke: "#c4d2e4",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 379.258,464.668 h 11.41 c 18.777,0 34,-15.223 34,-34 V 170 c 0,-18.777 -15.223,-34 -34,-34 H 209.332 c -18.777,0 -34,15.223 -34,34 v 11.078"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g46"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath52)",
    id: "g48"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath58)",
    id: "g54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "none",
      stroke: "#c4d2e4",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 424.59,419.332 H 436 c 18.777,0 34,-15.223 34,-34 V 124.668 c 0,-18.777 -15.223,-34 -34,-34 H 254.668 c -18.777,0 -34,15.223 -34,34 v 11.078"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "none",
      stroke: "#c4d2e4",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 294.332,447.668 h 34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "none",
      stroke: "#c4d2e4",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 181,413.668 h 34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "none",
      stroke: "#c4d2e4",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 181,391 H 328.332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "none",
      stroke: "#c4d2e4",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 181,368.332 H 328.332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "none",
      stroke: "#c4d2e4",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 181,345.668 H 328.332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "none",
      stroke: "#c4d2e4",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 181,323 H 328.332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "none",
      stroke: "#c4d2e4",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 181,300.332 H 328.332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "none",
      stroke: "#c4d2e4",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 181,277.668 H 328.332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "none",
      stroke: "#c4d2e4",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 181,255 H 328.332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "none",
      stroke: "#c4d2e4",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 181,232.332 H 328.332"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g82"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath88)",
    id: "g84"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath94)",
    id: "g90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path96",
    style: {
      fill: "#e2c300",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 290,290 H 560 V 560 H 290 Z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    style: {
      fill: "none",
      stroke: "#204a78",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 401.309,423.641 19.464,-22.02 26.317,45.149"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTramites);
export default __webpack_public_path__ + "static/media/Tramites.644b1a669f4025b8e90072bb2149c745.svg";
export { ForwardRef as ReactComponent };